import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Address } from '../../../../../generated/generated-types';
import { AddressHeaderCardWidgetComponent } from '../address-header-card-widget/address-header-card-widget.component';

@Component({
  selector: 'app-formly-address-header-card-widget',
  templateUrl: './formly-address-header-card-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AddressHeaderCardWidgetComponent,
  ]
})
export class FormlyAddressHeaderCardWidgetComponent extends FieldType {

  async onAssetChoose(resolveCallback: () => Promise<void>) {
    const { detailComponent, detailModel } = this.getDetailComponentAndModel();
    //first save existing contact
    if (detailComponent && detailModel && detailComponent.modelIsDirtySig())
      await detailComponent.save(detailModel, null, true);

    // After save is complete, call the callback to let the child component continue
    await resolveCallback();
  }

  async onAddressChanged(address: Address) {
    const { detailComponent, detailModel } = this.getDetailComponentAndModel();
    if (detailComponent && detailModel) {
      let contactOfDetailComponent = { ...detailModel.address, ...address };
      detailModel.address = contactOfDetailComponent;
      await detailComponent.setModel(detailModel);
    }
  }

  getDetailComponentAndModel() {
    const detailComponent = this.options?.formState?.detailComponent;
    if (detailComponent?.detailModelSig()) {
      let detailModel = detailComponent.detailModelSig();
      return { detailComponent, detailModel };
    }
    return { detailComponent, detailModel: null };
  }


}